import React from "react";

const getIcons = () => [
  {
    id: 0,
    name: "warning",
    svg: (
      <>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </>
    ),
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px",
  },
  {
    id: 1,
    name: "chevron",
    svg: (
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#180048"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1l4.5 5L10 1"
      />
    ),
    viewBox: "0 0 11 7",
    height: "7px",
    width: "11px",
  },
  {
    id: 2,
    name: "tick",
    svg: (
      <path
        fillRule="nonzero"
        d="M158.291 4.686c5.628-5.987 15.042-6.275 21.025-.644 5.386 5.068 6.158 13.203 2.156 19.144l-1.512 1.892L76.33 135.314c-4.855 5.164-12.573 6.117-18.474 2.575l-1.894-1.347L5.342 94.26c-6.306-5.267-7.15-14.652-1.886-20.961 4.786-5.736 12.974-6.956 19.16-3.173l1.791 1.286 39.854 33.277L158.29 4.686z"
      />
    ),
    viewBox: "0 0 184 140",
    height: "140px",
    width: "184px",
  },
  {
    id: 3,
    name: "chevron-current",
    svg: (
      <>
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#6933D3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M1 1l4.5 5L10 1"
        />
      </>
    ),
    viewBox: "0 0 11 7",
    height: "7px",
    width: "11px",
  },
  {
    id: 7,
    name: "chevronright",
    className: "linkchevron",
    svg: (
      <path
        fill="none"
        stroke="#180048"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 10l5-4.5L1 1"
      />
    ),
    viewBox: "0 0 7 11",
    width: "7px",
    height: "11px",
  },
  {
    id: 17,
    name: "plus",
    svg: (
      <>
        <path
          d="M12.5 0v25M25 12.5H0"
          fill="none"
          stroke="#180048"
          strokeWidth="3"
        />
      </>
    ),
    viewBox: "0 0 25 25",
    width: "25px",
    height: "25px",
  },
  {
    id: 20,
    name: "copy",
    svg: (
      <>
        <path
          fillRule="evenodd"
          d="M10.316 0H1.474C.664 0 0 .695 0 1.545v10.819h1.474V1.545h8.842V0zm-.737 3.09L14 7.728v7.727c0 .85-.663 1.546-1.474 1.546H4.414c-.81 0-1.467-.695-1.467-1.546l.008-10.818c0-.85.656-1.545 1.466-1.545H9.58zm3.316 5.41H8.842V4.25l4.053 4.25z"
          clipRule="evenodd"
        />
      </>
    ),
    viewBox: "0 0 14 17",
    width: "14px",
    height: "17px",
  },
  {
    id: 69,
    name: "play",
    svg: (
      <>
        <path
          fill="#2A61FF"
          d="M0 .729v7.542c0 .575.686.925 1.214.611l6.42-3.77c.488-.284.488-.94 0-1.23L1.213.117C.686-.196 0 .154 0 .729z"
        />
      </>
    ),
    viewBox: "0 0 8 9",
    width: "8px",
    height: "9px",
  },
  {
    id: 70,
    name: "close",
    svg: (
      <>
        <path
          fill="#000"
          d="M5.523 4.5l2.415-2.39.492-.493c.07-.07.07-.187 0-.281L7.914.82c-.094-.07-.21-.07-.281 0L4.75 3.727 1.844.82c-.07-.07-.188-.07-.282 0l-.515.516c-.07.094-.07.21 0 .281L3.953 4.5 1.047 7.406c-.07.07-.07.188 0 .282l.516.515c.093.07.21.07.28 0L4.75 5.297 7.14 7.71l.493.492c.07.07.187.07.281 0l.516-.515c.07-.094.07-.211 0-.282L5.523 4.5z"
        />
      </>
    ),
    viewBox: "0 0 8 9",
    width: "8px",
    height: "9px",
  },
  {
    id: 71,
    name: "play-testimonial",
    svg: (
      <>
        <path
          fill="#ffffff"
          d="M0 .729v7.542c0 .575.686.925 1.214.611l6.42-3.77c.488-.284.488-.94 0-1.23L1.213.117C.686-.196 0 .154 0 .729z"
        />
      </>
    ),
    viewBox: "0 0 8 9",
    width: "5.33px",
    height: "6px",
  },
  {
    id: 70,
    name: "whiteclose",
    svg: (
      <>
        <path
          fill="#fff"
          d="M5.523 4.5l2.415-2.39.492-.493c.07-.07.07-.187 0-.281L7.914.82c-.094-.07-.21-.07-.281 0L4.75 3.727 1.844.82c-.07-.07-.188-.07-.282 0l-.515.516c-.07.094-.07.21 0 .281L3.953 4.5 1.047 7.406c-.07.07-.07.188 0 .282l.516.515c.093.07.21.07.28 0L4.75 5.297 7.14 7.71l.493.492c.07.07.187.07.281 0l.516-.515c.07-.094.07-.211 0-.282L5.523 4.5z"
        />
      </>
    ),
    viewBox: "0 0 8 9",
    width: "8px",
    height: "9px",
  },
  {
    id: 72,
    name: "chevron-light",
    fill: "none",
    svg: (
      <path
        d="M9 1L5 5.5L1 1"
        stroke="#0A144A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    viewBox: "0 0 10 6",
    height: "6px",
    width: "10px",
  },
  {
    id: 73,
    name: "lightclose",
    svg: (
      <>
        <path
          d="M5.5 0.5L0.5 5.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.5 0.5L5.5 5.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    viewBox: "0 0 6 6",
    width: "6px",
    height: "6px",
  },
];
export default getIcons;
